import { Button, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { selectedDayType } from "../../utils/types";

export const DaySelection = ({
  selectedDays,
  setSelectedDays,
  windowSize = 1000,
  preselectToday = false,
  preselectCurrentWeek = false,
  setAvailableDays,
  showWeekNavigation = false,
}: {
  selectedDays;
  setSelectedDays;
  windowSize?: number;
  preselectToday?: boolean;
  preselectCurrentWeek?: boolean;
  setAvailableDays?: (days: selectedDayType[]) => void;
  showWeekNavigation?: boolean;
}) => {
  const [nextDays, setNextDays] = useState<selectedDayType[]>([]);
  const [weekOffset, setWeekOffset] = useState(0);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    day: selectedDayType,
  ) => {
    if (event.target.checked) {
      setSelectedDays([...selectedDays, day]);
    } else {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    }
  };

  // set next days
  const getNextWorkdays = (currentDate: moment.Moment, windowSize) => {
    const nextWorkdays: {
      days: moment.Moment[];
      abbr: string;
    }[] = [];
    // Funktion zur Ermittlung der Anzahl der auszuwählenden Tage
    // Anforderung: "Heute und plus 11 Tage in die Zukunft für alle User"
    let daysToShow = 12; // 1 (Heute) + 11 (Zukunft) = 12 Tage
    // const lastWeek = {
    //   abbr: "Letzte Woche",
    //   days: [],
    // };
    // for (let i = 7; i > 0; i--) {
    //   lastWeek.days.push(currentDate.clone().subtract(i, "days"));
    // }
    // nextWorkdays.push(lastWeek);
    if (currentDate.isoWeekday() <= 50) {
      //vorher 5 (Werktage)
      let firstAbbr = currentDate
        .format("dd")
        .replace("Tu", "Di")
        .replace("We", "Mi")
        .replace("Th", "Do")
        .replace("Su", "So");
      
      nextWorkdays.push({
        abbr: weekOffset === 0 ? "Heute" : firstAbbr,
        days: [currentDate.clone()],
      });
    }
    while (nextWorkdays.length < daysToShow) {
      currentDate = currentDate.add(1, "day");
      if (currentDate.isoWeekday() <= 50) {
        //vorher 5 (Werktage)
        let newAbbr = currentDate
          .format("dd")
          .replace("Tu", "Di")
          .replace("We", "Mi")
          .replace("Th", "Do")
          .replace("Su", "So");
        
        nextWorkdays.push({
          abbr: newAbbr,
          days: [currentDate.clone()],
        });
      }
    }
    // const nextWeek = {
    //   abbr: "Nächste Woche",
    //   days: [],
    // };
    // for (let i = 1; i <= 7; i++) {
    //   nextWeek.days.push(currentDate.clone().add(i, "days"));
    // }
    // nextWorkdays.push(nextWeek);
    setNextDays(nextWorkdays);
    if (setAvailableDays) {
      setAvailableDays(nextWorkdays);
    }
  };

  useEffect(() => {
    const currentDate = moment().startOf("day").add(weekOffset, "weeks");
    getNextWorkdays(currentDate, windowSize);
  }, [weekOffset]);

  useEffect(() => {
    if (preselectToday && nextDays?.filter((day) => day.abbr === "Heute")[0])
      setSelectedDays([
        ...selectedDays,
        nextDays?.filter((day) => day.abbr === "Heute")[0],
      ]);
    if (
      preselectCurrentWeek &&
      nextDays?.filter(
        (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche",
      )
    )
      setSelectedDays([
        ...selectedDays,
        ...nextDays?.filter(
          (day) => day.abbr !== "Letzte Woche" && day.abbr !== "Nächste Woche",
        ),
      ]);
  }, [nextDays]);

  const renderWeekNavigation = () => {
    if (!showWeekNavigation) return null;
    
    const prevWeekKW = moment().add(weekOffset - 1, "weeks").isoWeek();
    const currentKW = moment().isoWeek();
    const nextWeekKW = moment().add(weekOffset + 1, "weeks").isoWeek();

    return (
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: "10px", gap: "10px" }}>
        <Button onClick={() => setWeekOffset(weekOffset - 1)} variant="outlined" style={{ borderRadius: "20px" }}>
          Vorherige (KW {prevWeekKW})
        </Button>
        {weekOffset !== 0 && (
          <Button onClick={() => setWeekOffset(0)} variant="outlined" style={{ borderRadius: "20px" }}>
            Aktuelle (KW {currentKW})
          </Button>
        )}
        <Button onClick={() => setWeekOffset(weekOffset + 1)} variant="outlined" style={{ borderRadius: "20px" }}>
          Nächste (KW {nextWeekKW})
        </Button>
      </div>
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: "100%" }}>
      {renderWeekNavigation()}
      <div 
        style={{ 
          width: "100%", 
          overflowX: "auto", 
          display: "flex", 
          padding: "5px 0",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <FormGroup 
          aria-label="position" 
          row 
          style={{ 
            flexWrap: windowSize < 700 ? "nowrap" : "wrap", 
            margin: windowSize < 700 ? "0" : "0 auto",
            justifyContent: windowSize < 700 ? "flex-start" : "center",
            padding: "0 10px"
          }}
        >
          {nextDays &&
            nextDays
              .filter(
                (day) =>
                  day.abbr !== "Nächste Woche" && day.abbr !== "Letzte Woche",
              )
              .map((day, index) => (
                <FormControlLabel
                  key={day.days[0].format("DD.MM.YYYY")}
                  value="top"
                  control={
                    <Checkbox
                      checked={selectedDays.some((d) => d.days[0].format("YYYY-MM-DD") === day.days[0].format("YYYY-MM-DD"))}
                      onChange={(event) => {
                        if (event.target.checked) {
                          setSelectedDays([day]);
                        } else {
                          setSelectedDays([]);
                        }
                      }}
                    />
                  }
                  label={
                    <div style={{ 
                      display: "flex", 
                      flexDirection: windowSize < 700 ? "column" : "row", 
                      alignItems: "center",
                      gap: windowSize < 700 ? "2px" : "6px",
                      lineHeight: "1.2"
                    }}>
                      <span style={{ whiteSpace: "nowrap", fontSize: windowSize < 700 ? "0.85rem" : "1rem" }}>
                        {day.abbr}
                      </span>
                      <span style={{ whiteSpace: "nowrap", fontSize: windowSize < 700 ? "0.75rem" : "0.9rem", color: "gray" }}>
                        {day.days[0].format("DD.MM.")}
                      </span>
                    </div>
                  }
                  labelPlacement="top"
                  style={{ 
                    margin: windowSize < 700 ? "0 4px" : "8px", 
                    flexShrink: 0 
                  }}
                />
              ))}
        </FormGroup>
      </div>
    </div>
  );
};
